import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";
import Select from "react-select";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/admin/setting/home-banner/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
    clearErrors,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("name", data?.name);
      finalData.append("alt_tag", data?.alt_tag ?? "");
      finalData.append("redirect_url", data?.redirect_url);

      // finalData.append("category_id", data?.category_id?.value);

      // Only append new file if user selected one
      if (data.image && data.image[0] instanceof File) {
        finalData.append("image", data.image[0]);
      }

      const response = await putData(
        `/admin/setting/home-banner/${id}`,
        finalData,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null);
  const [previewType, setPreviewType] = useState(null); // "image" | "video"

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const isVideo = file.type.startsWith("video/");
      setPreviewType(isVideo ? "video" : "image");

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      clearErrors("image");
    } else {
      setImagePreview(null);
      setPreviewType(null);
    }
  };

  // Helper to detect if existing file is video
  const isVideoFile = (path) => {
    if (!path) return false;
    const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv"];
    return videoExtensions.some((ext) => path.toLowerCase().endsWith(ext));
  };

  const [countries, setCountries] = useState([]);

  const GetAllCategory = async () => {
    const response = await getData("/common/masters/all-p-category");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "p_category_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Banner
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              {/* Category field remains commented */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Name</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Name Is Required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Form.Label className="text-left">
                      Image / GIF / Video
                    </Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        type="file"
                        {...register("image", {
                          // validation remains commented (same as Add)
                        })}
                        accept="image/*,video/*,.gif"
                        onChange={handleImageChange}
                      />
                    </Form.Group>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Row>
                </div>
                <div className="main-form-section mt-3">
                  <Form.Group className="mt-3">
                    <Form.Label>Alt Tag</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="alt_tag"
                        placeholder="Alt Tag"
                        className={classNames("", {
                          "is-invalid": errors?.alt_tag,
                        })}
                        {...register("alt_tag", {
                          validate: (value) =>
                            !value ||
                            value.length <= 255 ||
                            "Data must be 255 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.alt_tag && (
                      <span className="text-danger">{errors.alt_tag.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Form.Label>Preview</Form.Label>

                  {/* Existing file from server */}
                  {typeof getValues("image") === "string" && !imagePreview ? (
                    <div className="image-preview-container">
                      {isVideoFile(getValues("image")) ? (
                        <video
                          src={IMG_URL + getValues("image")}
                          controls
                          autoPlay
                          muted
                          loop
                          width="700"
                          style={{ maxWidth: "100%" }}
                          className="image-preview"
                        />
                      ) : (
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          width="700"
                          style={{ maxWidth: "100%" }}
                        />
                      )}
                    </div>
                  ) : (
                    /* Newly selected file */
                    imagePreview && (
                      <div className="image-preview-container">
                        {previewType === "video" ? (
                          <video
                            src={imagePreview}
                            controls
                            autoPlay
                            muted
                            loop
                            width="700"
                            style={{ maxWidth: "100%" }}
                            className="image-preview"
                          />
                        ) : (
                          <img
                            src={imagePreview}
                            alt="Preview"
                            className="image-preview"
                            width="700"
                            style={{ maxWidth: "100%" }}
                          />
                        )}
                      </div>
                    )
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div>
                      <Form.Label>Redirect Link</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="e.g. /products or https://example.com"
                        className={classNames("", {
                          "is-invalid": errors?.redirect_url,
                        })}
                        {...register("redirect_url", {
                          required: "Redirect Link is required",
                          validate: (value) => {
                            if (
                              value.startsWith("/") ||
                              /^https?:\/\/.+/i.test(value)
                            ) {
                              return true;
                            }
                            return "Enter a valid URL or website page path";
                          },
                        })}
                      />
                    </InputGroup>

                    {errors.redirect_url && (
                      <span className="text-danger">
                        {errors.redirect_url.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
